import { FieldArray, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { CustomArraySelectField } from "../../../../../partials/content/Forms";
import { saveVisitActivities } from "../../../../../services/crm/salesJourney";
import Swal from "sweetalert2";
import { Table } from "react-bootstrap";
import { DialogActions } from "@material-ui/core";
import Illustration from "../../../../../partials/content/Illustration";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { getSalesActivities } from "../../../../../services/setup/crm/crmSetupService";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
import { isMobile } from "react-device-detect";
function ActivityForm({ visit, onConfirmSave, onCloseDialog }) {
  const [activities, setActivities] = useState({
    data: [
      {
        ID: 0,
        visitID: visit.ID,
        activityID: 0,
        statusID: 0,
        note: "",
      },
    ],
  });
  const [salesActivities, setSalesActivities] = useState([]);
  useEffect(() => {
    getSalesActivitiesData();
  }, [visit]);
  const activitiesSchema = yup.object().shape({
    data: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        visitID: yup.number(),
        activityID: yup.number().min(1, "Activity is required"),
        statusID: yup.number().min(1, "Status is required"),
        note: yup.string(),
        tasks: yup.array().of(
          yup.object().shape({
            ID: yup.number(),
            title: yup.string(),
            description: yup.string(),
            deadlineDate: yup.date(),
          })
        ),
        dsSetup: yup.bool(),
        deleteInd: yup.bool(),
      })
    ),
  });
  return (
    <React.Fragment>
      <Formik
        initialValues={activities}
        enableReinitialize={true}
        validateOnChange={false}
        validationSchema={activitiesSchema}
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Visit Activity ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveVisitActivities(values.data).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        {({
          dirty,
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <React.Fragment>
            <form
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
              onKeyDown={onPreventEnterSubmitting}
            >
              {isMobile ? (
                <React.Fragment>
                  <h5>Activity</h5>
                  <CustomArraySelectField
                    arrayName="data"
                    propertyName="activityID"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    index={0}
                    value={values}
                    touched={touched}
                    errors={errors}
                    options={salesActivities}
                  />
                  <br /> <br />
                  <h5>Status</h5>
                  <CustomArraySelectField
                    arrayName="data"
                    propertyName="statusID"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    index={0}
                    value={values}
                    touched={touched}
                    errors={errors}
                    options={[
                      { label: "Unstarted", value: 1 },
                      { label: "Started", value: 2 },
                      { label: "Finished", value: 3 },
                      { label: "Cancelled", value: 9 },
                    ]}
                  />
                  <br /> <br />
                  <h5>Note</h5>
                  <FormArrayTextField
                    arrayPropName="data"
                    index={0}
                    propName="note"
                    margin="none"
                  />
                </React.Fragment>
              ) : (
                <FieldArray name="data">
                  {({ push, remove }) => (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="card">
                            <Table borderless size="sm" responsive="xl">
                              {visit.statusID < 9 &&
                              values.data &&
                              values.data.length > 0 ? (
                                <thead className="text-center">
                                  <tr>
                                    <th style={{ width: "30%" }}>Activity</th>
                                    <th style={{ width: "25%" }}>Status</th>
                                    <th style={{ width: "40%" }}>Note</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                              ) : null}
                              <tbody>
                                {visit.statusID < 9 &&
                                values.data &&
                                values.data.length > 0 ? (
                                  values.data.map((activity, index) => (
                                    <tr key={index}>
                                      <td>
                                        <CustomArraySelectField
                                          arrayName="data"
                                          propertyName="activityID"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          index={index}
                                          value={values}
                                          touched={touched}
                                          errors={errors}
                                          options={salesActivities}
                                        />
                                      </td>
                                      <td>
                                        <CustomArraySelectField
                                          arrayName="data"
                                          propertyName="statusID"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          index={index}
                                          value={values}
                                          touched={touched}
                                          errors={errors}
                                          options={[
                                            { label: "Unstarted", value: 1 },
                                            { label: "Started", value: 2 },
                                            { label: "Finished", value: 3 },
                                            { label: "Cancelled", value: 9 },
                                          ]}
                                        />
                                      </td>
                                      <td>
                                        <FormArrayTextField
                                          arrayPropName="data"
                                          index={index}
                                          propName="note"
                                          margin="none"
                                        />
                                      </td>
                                      <td
                                        style={{ whiteSpace: "nowrap" }}
                                        className="text-center"
                                      >
                                        {index > 0 ? (
                                          <BootstrapTooltip
                                            title={
                                              activity.deleteInd
                                                ? "Undo Delete"
                                                : "Delete Activity Item"
                                            }
                                          >
                                            <button
                                              type="button"
                                              className={`btn btn-icon btn-label-${
                                                activity.deleteInd
                                                  ? "warning"
                                                  : "danger"
                                              } btn-md btn-circle mx-1`}
                                              onClick={() => {
                                                if (activity.ID > 0) {
                                                  setFieldValue(
                                                    `data[${index}].deleteInd`,
                                                    !activity.deleteInd
                                                  );
                                                } else {
                                                  remove(index);
                                                }
                                              }}
                                            >
                                              {activity.deleteInd ? (
                                                <i className="fas fa-undo-alt"></i>
                                              ) : (
                                                <i className="fas fa-trash-alt"></i>
                                              )}
                                            </button>
                                          </BootstrapTooltip>
                                        ) : null}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="4"
                                    >
                                      <Illustration
                                        imageSource="INVIFO CRM.png"
                                        guidance="You don't have any Visit Activity items yet"
                                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                        size="sm"
                                      ></Illustration>
                                    </td>
                                  </tr>
                                )}
                                {visit.statusID !== 3 &&
                                visit.statusID !== 9 ? (
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="4"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                        onClick={() => {
                                          push({
                                            ID: 0,
                                            visitID: visit.ID,
                                            activityID: 0,
                                            statusID: 0,
                                            userID: 0,
                                            userName: "",
                                            note: "",
                                            dsSetup: false,
                                            tasks: [],
                                            directSales: {},
                                            deleteInd: false,
                                          });
                                        }}
                                      >
                                        <i className="fas fa-plus-circle"></i>
                                        Add Activity
                                      </button>
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </FieldArray>
              )}
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={onCloseDialog}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
                {visit.statusID < 9 ? (
                  <button
                    type="submit"
                    className="btn btn-success btn-md btn-pill btn-bold"
                  >
                    <i className="fas fa-save"></i>
                    Save
                  </button>
                ) : null}
              </DialogActions>
            </form>
          </React.Fragment>
        )}
      </Formik>
    </React.Fragment>
  );

  async function getSalesActivitiesData() {
    const salesActivitiesTmp = [];
    const response = await getSalesActivities();
    const { data } = response.data;
    const { salesActivities } = data;
    salesActivities.forEach((item) => {
      salesActivitiesTmp.push({
        label: item.salesActivityName,
        value: item.ID,
      });
    });

    setSalesActivities(salesActivitiesTmp);
  }
}

export default ActivityForm;
